import React from 'react';
import PremiumSettingsCopyForm from './premiumSettingsCopyForm';
import ModalWrapper from '../../helpers/modalWrapper';
import { SIZE_LG } from '../../helpers/constants';

const PremiumSettingsCopyFormModal = props => {
    const {
        onClose,
        isOpen,
        groupCaseAndSubTypes,
        caseTypes,
        subCaseTypes,
        groupOptions,
        worksourcesOptions,
        getSolicitorGroupCaseTypes,
        requestGetSolicitorGroupWorkSources,
        changeNewPremiumStoreSettings,
        premiumSettingsId,
        premiumSettingType,
        stagedId,
    } = props;

    return (
        <>
            <ModalWrapper
                isOpen={isOpen}
                onClose={onClose}
                // modalTestId={}
                size={SIZE_LG}
            >
                <PremiumSettingsCopyForm
                    groupCaseAndSubTypes={groupCaseAndSubTypes}
                    caseTypes={caseTypes}
                    subCaseTypes={subCaseTypes}
                    groupOptions={groupOptions}
                    worksourcesOptions={worksourcesOptions}
                    premiumSettingsId={premiumSettingsId}
                    getSolicitorGroupCaseTypes={getSolicitorGroupCaseTypes}
                    requestGetSolicitorGroupWorkSources={requestGetSolicitorGroupWorkSources}
                    changeNewPremiumStoreSettings={changeNewPremiumStoreSettings}
                    stagedId={stagedId}
                    premiumSettingType={premiumSettingType}
                    onCancel={onClose}
                />
            </ModalWrapper>
        </>
    );
};

export default PremiumSettingsCopyFormModal;
